import L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

const TransformedImage = ({ img, corners }) => {
  const map = useMap();
  useEffect(() => {
    const transformImageOverlay = L.DomUtil.create(
      "img",
      "leaflet-image-layer"
    );
    transformImageOverlay.src = img;
    transformImageOverlay.style.position = "absolute";
    transformImageOverlay.style.backgroundColor = "silver";

    const [topLeft, topRight, bottomRight] = corners;

    const updatePosition = () => {
      const topLeftPoint = map.latLngToLayerPoint(topLeft);
      const topRightPoint = map.latLngToLayerPoint(topRight);
      const bottomRightPoint = map.latLngToLayerPoint(bottomRight);

      const width = Math.sqrt(
        Math.pow(topRightPoint.x - topLeftPoint.x, 2) +
          Math.pow(topRightPoint.y - topLeftPoint.y, 2)
      );

      const height = Math.sqrt(
        Math.pow(bottomRightPoint.x - topRightPoint.x, 2) +
          Math.pow(bottomRightPoint.y - topRightPoint.y, 2)
      );

      const angle = Math.atan2(
        topRightPoint.y - topLeftPoint.y,
        topRightPoint.x - topLeftPoint.x
      );

      transformImageOverlay.style.width = `${width}px`;
      transformImageOverlay.style.height = `${height}px`;

      transformImageOverlay.style.transformOrigin = "0 0";

      transformImageOverlay.style.transform = `
        translate(${topLeftPoint.x}px, ${topLeftPoint.y}px)
        rotate(${angle}rad)
      `;
    };

    const pane = map.getPane("overlayPane");
    pane.appendChild(transformImageOverlay);

    map.on("zoomstart", updatePosition);
    map.on("zoom", updatePosition);
    map.on("zoomend", updatePosition);

    updatePosition();

    return () => {
      pane.removeChild(transformImageOverlay);
      map.off("zoomstart", updatePosition);
      map.off("zoom", updatePosition);
      map.off("zoomend", updatePosition);
    };
  }, [map, img, corners]);

  return null;
};

export default TransformedImage;
